(() => {
  'use strict';
  const rootUrl = document.body.dataset.rootUrl || '/';
  const cartUrl = rootUrl + 'cart';
  const currency = document.body.dataset.currency || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
  const init = (root = document) => {
    if (window.lucide) window.lucide.createIcons();
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const form = section.querySelector('.ff-purchase-form');
      const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
      const quantity = form.elements.quantity;
      const button = form.querySelector('[data-add-button]');
      const message = form.querySelector('[data-add-message]');
      const cartLink = form.querySelector('[data-cart-link]');
      const selected = () => variants.find(v => String(v.id) === form.elements.id.value);
      const update = (changeUrl = false) => {
        const variant = selected();
        if (!variant) return;
        section.querySelector('[data-product-price]').textContent = variant.priceText;
        const compare = section.querySelector('[data-compare-price]');
        compare.textContent = variant.compareText;
        compare.hidden = !variant.compareText;
        section.querySelector('[data-availability]').textContent = variant.available ? 'Available to order' : 'Sold out';
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
        const count = Number(quantity.value);
        section.querySelector('[data-selection-total]').textContent = Number.isInteger(count) && count > 0 ? money(variant.price * count) : 'Choose a quantity';
        if (changeUrl) {
          message.hidden = true;
          cartLink.hidden = true;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
          if (variant.image) {
            const img = section.querySelector('.ff-main-product-image');
            if (img) { img.src = variant.image; img.removeAttribute('srcset'); }
          }
        }
      };
      form.querySelector('[data-variant-select]')?.addEventListener('change', () => update(true));
      quantity.addEventListener('input', () => update());
      form.querySelectorAll('[data-quantity-step]').forEach(control => control.addEventListener('click', () => {
        const count = Number(quantity.value) || 1;
        quantity.value = Math.max(1, count + Number(control.dataset.quantityStep));
        update();
      }));
      form.querySelector('[data-quantity-four]')?.addEventListener('click', () => { quantity.value = 4; update(); });
      section.querySelectorAll('[data-gallery-image]').forEach(control => control.addEventListener('click', () => {
        const img = section.querySelector('.ff-main-product-image');
        if (!img) return;
        img.src = control.dataset.galleryImage;
        img.alt = control.dataset.galleryAlt;
        img.removeAttribute('srcset');
        section.querySelectorAll('[data-gallery-image]').forEach(other => {
          other.classList.toggle('active', other === control);
          other.setAttribute('aria-pressed', String(other === control));
        });
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity() || button.disabled) return;
        const data = new FormData(form);
        button.disabled = true;
        button.textContent = 'Adding…';
        message.hidden = true;
        cartLink.hidden = true;
        try {
          const response = await fetch(cartUrl + '/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'This selection could not be added.');
          message.textContent = 'Added to your cart.';
          message.classList.remove('ff-error');
          cartLink.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          message.textContent = error.message === 'Failed to fetch' ? 'Connection interrupted. Check your cart before trying again.' : error.message;
          message.classList.add('ff-error');
        } finally {
          message.hidden = false;
          update();
        }
      });
      update();
    });
    root.querySelectorAll('[data-filter-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const disclosure = form.querySelector('.ff-catalog-filters');
      if (disclosure && window.matchMedia('(max-width: 900px)').matches) disclosure.open = false;
      form.querySelector('[data-sort]')?.addEventListener('change', () => form.requestSubmit());
    });
    root.querySelectorAll('[data-fitment-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const make = form.querySelector('[data-fitment-make]');
      const model = form.querySelector('[data-fitment-model]');
      const modelMap = JSON.parse(form.querySelector('[data-model-map]').textContent);
      const refreshModels = () => {
        model.replaceChildren(new Option('Model', ''));
        (modelMap[make.value] || []).forEach(label => model.add(new Option(label, label)));
        model.disabled = !make.value;
      };
      make.addEventListener('change', refreshModels);
      refreshModels();
    });
  };
  document.addEventListener('click', event => {
    const close = event.target.closest('.ff-menu-close');
    if (close) {
      const menu = close.closest('details');
      menu.open = false;
      menu.querySelector('summary').focus();
    }
    const mobileLink = event.target.closest('.ff-mobile-menu a');
    if (mobileLink) mobileLink.closest('details').open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.ff-mobile-menu[open], .ff-nav-dropdown[open]').forEach(menu => {menu.open = false; menu.querySelector('summary').focus();});
    }
  });
  document.addEventListener('cart:refresh', async () => {
    try {
      const response = await fetch(cartUrl + '.js');
      if (!response.ok) return;
      const cart = await response.json();
      const counter = document.getElementById('ff-cart-count');
      if (counter) { counter.textContent = cart.item_count; counter.hidden = cart.item_count === 0; }
    } catch (_) {}
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
